<app-base-page-template>
  <app-base-page-content-template>
    <app-transaction-rules-grid>
    </app-transaction-rules-grid>
  </app-base-page-content-template>
</app-base-page-template>
